module.exports = __webpack_public_path__ + "img/sms-campaigns.41d8bc77.png";